import { ModelFilter } from "@react3l/react3l/core";
import { IdFilter, StringFilter } from "@react3l/advanced-filters";

export class ResourceTranslationLanguageFilter extends ModelFilter {
  public id?: IdFilter = new IdFilter();
  public code?: StringFilter = new StringFilter();
  public name?: StringFilter = new StringFilter();
}
